/* ============================================================
   BEO - recherche : les champs du theme, et le libelle des resultats
   (2026-09-10).

   1. La page /search interroge les titres (`title:cheese`) parce que les
      descriptions produit polluent l'index : voir le commentaire en tete
      de assets/beo-app-search.js. Mais le champ du header, present sur
      toutes les pages, et le " Search again " de la page de resultats
      envoyaient encore le mot brut, donc les 98 resultats. On leur
      applique la meme regle, sans toucher aux fichiers du theme.
      Le formulaire de la page Recherche est exclu : il gere deja son cas
      et enregistre le mot lisible en recherche recente.

   2. Faute d'origine du theme : la page de resultats affiche
      " 13 results found for for 'cheese' ". Le mot est double dans la
      chaine search.page.results de locales/en.default.json. On le
      corrige a l'affichage.

   Les deux blocs sont temporaires. Le premier saute le jour ou les
   descriptions sortiront du champ indexe. Le second saute des que la
   chaine de traduction est corrigee, ce qui se fait en une fois dans
   l'editeur de theme, " Modifier le contenu par defaut du theme ",
   en cherchant " results found ".
   ============================================================ */
(function () {
  "use strict";

  // 2026-10-31 : la requete se construit dans assets/beo-search-query.js (meme regle que l'app).
  var S = window.BEOSearch;
  function scopeTitle(term) { return S ? S.scoped(term) : (term || "").trim(); }
  function scopeTitleTyping(term) { return S ? S.typing(term) : (term || "").trim(); }

  /* --- 1a. Soumission des formulaires de recherche du theme --- */
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (!f || e.defaultPrevented || !f.getAttribute) return;
    // la page Recherche a son propre handler
    if (f.classList && f.classList.contains("beo-search__form")) return;
    if ((f.getAttribute("action") || "").indexOf("/search") !== 0) return;

    var q = f.querySelector('input[name="q"]');
    if (!q || !q.value.trim()) return;
    // 2026-10-23 (QA Philippe) : on construit l'URL nous-memes au lieu de reecrire
    // le champ visible, qui affichait « title:salmn » pendant le chargement.
    // Les autres champs du formulaire (type, options...) sont conserves.
    var params;
    try { params = new URLSearchParams(new FormData(f)); } catch (err) { q.value = scopeTitle(q.value); return; }
    params.set("q", scopeTitle(q.value));
    e.preventDefault();
    window.location.href = (f.getAttribute("action") || "/search") + "?" + params.toString();
  }, true);

  /* --- 1b. Menu deroulant du header ---
     Le constat du 10/09 (« component-predictive-search.js n'est charge sur
     aucune page ») etait faux : section-header.js le charge au PREMIER FOCUS
     du champ. Ce bloc tourne donc bel et bien.
     Le dernier mot part en prefixe (« bri* », 2026-10-31 : sans etoile Shopify
     perdait le Brie), voir assets/beo-search-query.js. Le libelle « Search for »
     est rendu lisible par la section ; son lien est refait ici pour mener a la
     meme recherche que la touche Entree (avant : 1 resultat d'un cote, 177 de
     l'autre pour « cheese »). */
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined("search-form").then(function () {
      var SF = customElements.get("search-form");
      if (!SF || !SF.prototype || SF.prototype.beoPatched) return;
      SF.prototype.beoPatched = true;

      var getResults = SF.prototype.getSearchResults;
      if (typeof getResults === "function") {
        SF.prototype.getSearchResults = function (q) {
          return getResults.call(this, scopeTitleTyping(q || ""));
        };
      }

      var render = SF.prototype.renderSearchResults;
      if (typeof render === "function") {
        SF.prototype.renderSearchResults = function (html) {
          var out = render.call(this, html);
          var more = this.predictiveSearchResults && this.predictiveSearchResults.querySelector("a.search-more");
          var typed = this.input ? this.input.value.trim() : "";
          if (more && typed) more.href = "/search?q=" + encodeURIComponent(scopeTitle(typed));
          return out;
        };
      }
    })["catch"](function () {});
  }

  /* --- 2. " found for for " -> " found for " ---
     Remplacement exact, sur la page de resultats seulement, et seulement
     sur les noeuds de texte qui contiennent cette suite precise. */
  function fixWording() {
    if (window.location.pathname.indexOf("/search") !== 0) return;
    var scope = document.querySelector("main") || document.body;
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.indexOf("found for for ") !== -1) {
        node.nodeValue = node.nodeValue.split("found for for ").join("found for ");
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fixWording);
  } else {
    fixWording();
  }
  window.addEventListener("pageshow", fixWording);
})();
